<h2 mat-dialog-title>Recuperar</h2>
<mat-dialog-content>
    <p>Seguro de recuperar el documento enviado?</p>
    <form [formGroup]="formRecuperar">
    <mat-form-field class="full-width">
        <mat-label>Motivo</mat-label>
        <input matInput formControlName="motivo" />
    </mat-form-field>
    </form>
</mat-dialog-content>
@if (saving) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<mat-dialog-actions>
    <button mat-button mat-dialog-close [disabled]="saving">cancelar</button>
    <button (click)="onAceptar()" [disabled]="saving" mat-flat-button>S&iacute;, recuperar</button>
</mat-dialog-actions>